/**
 * Идентификаторы касаний, которые ПОСЛЕ этого нативного touch-события можно
 * считать живыми. Нужны, чтобы отличить настоящий палец от фантома —
 * указателя Phaser, оставшегося зажатым после потерянного touchend
 * (системный свайп iOS, шторка уведомлений, long-press callout, сворачивание
 * вкладки). Такой фантом занимает один из двух доступных указателей касания,
 * и следующий же пан выглядит как pinch — поле зумится вместо перемещения.
 *
 * Правило зависит от типа события, потому что наш слушатель висит на window в
 * фазе перехвата и срабатывает РАНЬШЕ, чем Phaser обработает то же событие:
 *
 *  - touchend / touchcancel / touchmove — к живым добавляются changedTouches.
 *    На touchend последнего пальца event.touches пуст даже у самого обычного
 *    тапа: палец не потерян, он завершается именно этим событием. Не добавь мы
 *    changedTouches, указатель сбрасывался бы до того, как Phaser сматчит по
 *    его identifier это же событие, и pointerup (а с ним клик по ячейке)
 *    просто не происходил бы;
 *
 *  - touchstart — наоборот, changedTouches ВЫЧИТАЮТСЯ. Только что начавшиеся
 *    касания Phaser еще не раздал по указателям, поэтому уже зажатый указатель
 *    с таким же identifier — гарантированно фантом. Браузеры переиспользуют
 *    освободившиеся identifier (в Chrome это просто 0, 1, 2...), так что без
 *    вычитания фантом с identifier 0 выглядел бы живым при каждом следующем
 *    касании и не вычищался бы никогда — помогала только перезагрузка страницы.
 *
 * @param {TouchEvent} event - нативное touch-событие
 * @returns {Set<number>} идентификаторы живых касаний
 */
export const resolveLiveTouchIdentifiers = (event) => {
  const liveTouchIds = new Set();

  for (let i = 0; i < event.touches.length; i++) {
    liveTouchIds.add(event.touches[i].identifier);
  }

  const isTouchStart = event.type === 'touchstart';
  for (let i = 0; i < event.changedTouches.length; i++) {
    const changedId = event.changedTouches[i].identifier;
    if (isTouchStart) {
      liveTouchIds.delete(changedId);
    } else {
      liveTouchIds.add(changedId);
    }
  }

  return liveTouchIds;
};
